export interface ITasksExportTableHeaders {
    sectionName: string;
    description: string;
    assignedTo: string;
    dueDate: string;
    taskState: string;
    documents: string;
    annotations: string;
    companyName: string;
}
